import { Box, SxProps, Typography } from '@mui/material';
import { Accordion } from 'components/Accordion';
import { ConversationItem } from 'modules/conversations/types/ConversationItem';
import React from 'react';
import { TrackingEventName } from 'services/tracking/constants';
import { useTracking } from 'services/tracking/hooks';

const itemContainer: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap'
};

const CandidateDetailsItem = ({ value }: { value: string }) => {
  return (
    <Box sx={itemContainer}>
      <Typography variant="body2" fontWeight={500}>
        {value}
      </Typography>
    </Box>
  );
};

type Props = {
  conversation: ConversationItem;
};

export const CandidateDetails: React.FC<Props> = ({ conversation }) => {
  const { track } = useTracking();

  const items = [
    {
      value: conversation.participantEmailAddress
    },
    {
      value: conversation.participantPhoneNumber
    }
  ].filter((item) => !!item.value);

  return (
    <Accordion
      title="Candidate details"
      onClick={() => {
        track(TrackingEventName.CampaignDashboardConversationCandidateDetails);
      }}
    >
      {items.map((item) => (
        <CandidateDetailsItem key={item.value} value={item.value || ''} />
      ))}
    </Accordion>
  );
};
